import classnames from 'classnames'
import { FunctionalComponent } from 'preact'
// Too much files to change
/* eslint-disable import/no-internal-modules */
import Icon from '../../../../preact-components/assets'

export interface VoteButtonProps {
  onClick: () => void
  hasVoted: boolean
  votes: number
}

export const VoteButton: FunctionalComponent<VoteButtonProps> = ({ hasVoted, onClick, votes }) => (
  <button
    className={classnames('featured-topic__vote', {
      'featured-topic__vote--voted': hasVoted
    })}
    onClick={onClick}
  >
    <span className='featured-topic__voteAmount'>{votes}</span>
    <Icon icon='triangle' width={10} height={8} customClass='featured-topic__voteIcon' />
  </button>
)
